import { render, staticRenderFns } from "./AddEditAlertFormDialogComponent.vue?vue&type=template&id=0f2b18d0&"
import script from "./AddEditAlertFormDialogComponent.vue?vue&type=script&lang=js&"
export * from "./AddEditAlertFormDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports